module.exports = __webpack_public_path__ + "img/12.84fa4cab.jpg";